import { render, staticRenderFns } from "./ModalDisableRevenuecat.vue?vue&type=template&id=1816a8e7"
import script from "./ModalDisableRevenuecat.vue?vue&type=script&lang=js"
export * from "./ModalDisableRevenuecat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports